import L from "leaflet";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine";

import './Routing.css';
import { IPageState, AppState, store, Actions } from "../../appredux";

import { createControlComponent } from "@react-leaflet/core";
import "leaflet-routing-machine";
import { GreenIcon } from "./mapData";

import { GeoSearchControl, OpenStreetMapProvider, SearchControl } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';
import {  MapData, townName } from "./MapContainer";
import { TextField } from "@mui/material";
import { padding } from "@mui/system";
import { Info } from "../../api";
import { HaversineInM } from "./Distance";

//L.Marker.prototype.options.icon = GreenIcon

interface SearchProps {
  mapProp: MapData,
  map: any,
  contact: Info
}

const createRoutineMachineLayer = (props: SearchProps) => {
    const searchControl = GeoSearchControl({
        provider: new OpenStreetMapProvider({
          params: {
            countrycodes: 'pl',   
          }
        }),
        showMarker: false,
        autoComplete: true,
        //autoClose: true,


        //keepResult: false,
        //marker:  {},
        searchLabel: "Wskaż na mapie miejsce dostawy",//"Wpisz adres",
        // searchElement: {
        //   input: <input type="text" value="qwe"></input> as HTMLInputElement
        // },

        style: "bar",
        updateMap: false

      })

      function searchEventHandler(result: any) {
       
        let d = new MapData({
          klientAdres: result.location.label,  
          klientLat: result.location.y, 
          klientLng: result.location.x,
          distance: Math.round( HaversineInM(props.mapProp.obiektLat, props.mapProp.obiektLng, result.location.y, result.location.x) )
        })
        store.dispatch(Actions.pageState.setMap(d));

          //let lat = (props.mapProp.obiektLat + result.location.y) / 2
          //let lng = (props.mapProp.obiektLng + result.location.x) /2
        
          //props.map.current.target.setView(new L.LatLng(lat, lng), 15);
          props.map.current.target.flyToBounds([
            [props.mapProp.obiektLat, props.mapProp.obiektLng],
            [result.location.y, result.location.x]
        ], {padding: [100,100]});
        
      }
 
      props.map.current.target.on('geosearch/showlocation', searchEventHandler);

      // let input = document.getElementsByClassName("glass")
      // if(input.length >0 ){
      //   let inputValue = townName(props.contact.kontaktAdres)
      //   input[0].setAttribute("value", inputValue + ", ")
        
      // }

  
      // var latlng = L.latLng(50.5, 30.5);

      // var map = new L.Map('map', {
      //   'center': latlng,
      //   'zoom': 12,
      //   //'layers': [tileLayer]
      // });
      
      // map.on('click', function (e: any) {
      //   //marker.setLatLng(e.latlng);
      //   //updateLatLng(marker.getLatLng().lat, marker.getLatLng().lng);
      //   console.log(e)
      //   });

  return searchControl;
};
// @ts-ignore
const RoutingMachine = createControlComponent(createRoutineMachineLayer);

export default RoutingMachine;



